export * from './dashboard.component';



// WEBPACK FOOTER //
// ./src/app/dashboard/index.ts